import { useEffect, useState } from "react";

const EVENT = "tagforce:mobile-nav";
const CLOSE_SELECTOR = "[data-testid='mobile-nav-close']";
let opener = null;

const emit = (open) => window.dispatchEvent(new CustomEvent(EVENT, { detail: { open } }));

export const isMobileNavOpen = () => document.body.classList.contains("nav-open");

export function openMobileNav() {
  if (isMobileNavOpen()) return;
  opener = document.activeElement;
  document.body.classList.add("nav-open");
  emit(true);
  window.requestAnimationFrame(() => document.querySelector(CLOSE_SELECTOR)?.focus());
}

export function closeMobileNav({ restoreFocus = true } = {}) {
  if (!isMobileNavOpen()) return;
  document.body.classList.remove("nav-open");
  emit(false);
  if (restoreFocus && opener && document.contains(opener)) opener.focus();
  opener = null;
}

export const toggleMobileNav = () => (isMobileNavOpen() ? closeMobileNav() : openMobileNav());

export function useMobileNavOpen() {
  const [open, setOpen] = useState(isMobileNavOpen);
  useEffect(() => {
    const handler = (event) => setOpen(Boolean(event.detail?.open));
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);
  return open;
}
